import { render, staticRenderFns } from "./NonConformitiesTable.vue?vue&type=template&id=f678ce24&scoped=true&"
import script from "./NonConformitiesTable.vue?vue&type=script&lang=js&"
export * from "./NonConformitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f678ce24",
  null
  
)

export default component.exports